import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportSocialMedia } from 'dashboard/models/report/social-media';

interface SocialMediaProps {
  report: ReportSocialMedia;
  isRedacted: boolean;
}

export const SocialMedia = ({ report, isRedacted }: SocialMediaProps) => {
  const {
    'phone-number': phoneNumber,
    'email-address': emailAddress,
    'name-first': nameFirst,
    'name-middle': nameMiddle,
    'name-last': nameLast,
    'address-city': addressCity,
    'address-subdivision': addressSubdivision,
  } = report.attributes;

  return (
    <AttributeGrid>
      {phoneNumber && (
        <AttributeItem
          title='Phone number'
          value={phoneNumber}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-address-lookup__phone-number'
        />
      )}
      {emailAddress && (
        <AttributeItem
          title='Email address'
          value={emailAddress}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-address-lookup__email-address'
        />
      )}
      {nameFirst && (
        <AttributeItem
          title='First name'
          value={nameFirst}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-address-lookup__name-first'
        />
      )}
      {nameMiddle && (
        <AttributeItem
          title='Middle name'
          value={nameMiddle}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-address-lookup__name-middle'
        />
      )}
      {nameLast && (
        <AttributeItem
          title='Last name'
          value={nameLast}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-address-lookup__name-last'
        />
      )}
      {addressCity && (
        <AttributeItem
          title='City'
          value={addressCity}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-address-lookup__address-city'
        />
      )}
      {addressSubdivision && (
        <AttributeItem
          title='Subdivision'
          value={addressSubdivision}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-address-lookup__address-subdivision'
        />
      )}
    </AttributeGrid>
  );
};
